import { Input, Output, EventEmitter, ElementRef, Renderer2, Directive } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Directive()
export abstract class SelectBaseDirective {

  private _elem: HTMLSelectElement;
  private originalState = null;
  private options = [];

  //  tslint:disable-next-line:no-input-rename
  @Input('renci-error-text') public errorText = 'Error...';
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-error-full-text') public errorFullText = 'Error...';
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-load-text') public loadText = 'Loading...';
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-hidden-text') public hiddenText = '*** hidden ***';

  @Output() readonly dataSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    elem: ElementRef,
    private formControl: NgControl,
    private renderer: Renderer2,
    private storagePropertyName?: string) {
    this._elem = elem.nativeElement;

    if (storagePropertyName) {
      this.renderer.listen(this._elem, 'change', (e$) => {
        this.dataSelected.emit(this._elem.selectedOptions[0][storagePropertyName]);
      });
    }
  }

  abstract getData(): Observable<any[]>;

  loadData() {
    for (const option of this.options) {
      this.renderer.removeChild(this._elem, option);
    }
    this.options.length = 0;

    const loadingOpt = this.renderer.createElement('option');
    loadingOpt.text = this.loadText;
    loadingOpt.value = null;
    loadingOpt.selected = true;

    if (this.originalState == null) {
      this.originalState = this._elem.disabled;
      this._elem.disabled = true;
    }
    this.renderer.appendChild(this._elem, loadingOpt);

    this.getData()
      .subscribe(
        (res: any[]) => {
          const items = res || [];
          const storagePropertyName = this.storagePropertyName;

          for (const item of items) {
            const itemOpt = this.renderer.createElement('option');
            itemOpt.text = item.text;
            itemOpt.value = item.id;
            if (storagePropertyName) {
              itemOpt[storagePropertyName] = item;
            }
            this.renderer.appendChild(this._elem, itemOpt);
            this.options.push(itemOpt);
          }
          this.renderer.removeChild(this._elem, loadingOpt);
          this._elem.disabled = this.originalState;
          this._elem.selectedIndex = 0;
          this.originalState = null;

          //  set SELECT value after all available values are set
          if (this.formControl.value) {
            if (!items.find(m => m.id === this.formControl.value)) {
              const itemOpt = this.renderer.createElement('option');
              itemOpt.text = this.hiddenText;
              itemOpt.value = this.formControl.value;
              this.renderer.appendChild(this._elem, itemOpt);
              this.options.push(itemOpt);
            }
            this._elem.value = this.formControl.value;
          } else {
            this._elem.selectedIndex = 0;
          }
        },
        (error) => {
          loadingOpt.text = this.errorText;
          loadingOpt.selected = true;
          this.options.push(loadingOpt);
        }
      );
  }
}
